// Renders a branded recipe card onto a canvas for sharing/downloading.
function wrap(ctx, text, maxW) {
  const words = String(text || "").split(/\s+/);
  const lines = [];
  let line = "";
  for (const w of words) {
    const test = line ? line + " " + w : w;
    if (ctx.measureText(test).width > maxW && line) { lines.push(line); line = w; }
    else line = test;
  }
  if (line) lines.push(line);
  return lines;
}

export function buildRecipeCardCanvas(recipe) {
  const W = 900, pad = 56, contentW = W - pad * 2;
  const title = recipe?.title || "Ricetta";
  const n = recipe?.nutrition || {};
  const ingredients = recipe?.ingredients || [];
  const steps = recipe?.steps || [];

  // Measure pass on an offscreen ctx
  const measure = document.createElement("canvas").getContext("2d");
  const titleFont = "700 44px Georgia, serif";
  const h3Font = "700 24px Arial, sans-serif";
  const bodyFont = "22px Arial, sans-serif";

  let y = 150; // after header
  y += 60; // title area (assume up to 2 lines handled below)
  measure.font = titleFont;
  const titleLines = wrap(measure, title, contentW);
  y = 150 + 20 + titleLines.length * 52 + 10;
  if (n.kcal != null) y += 64; // nutrition pill row
  measure.font = bodyFont;
  y += 44; // "Ingredienti" heading
  const ingLines = ingredients.map((x) => wrap(measure, "• " + x, contentW));
  ingLines.forEach((ls) => { y += ls.length * 30; });
  y += 44; // "Preparazione" heading
  const stepLines = steps.map((x, i) => wrap(measure, `${i + 1}. ${x}`, contentW - 10));
  stepLines.forEach((ls) => { y += ls.length * 32 + 8; });
  y += 70; // footer
  const H = Math.max(700, y);

  const canvas = document.createElement("canvas");
  const scale = 2;
  canvas.width = W * scale; canvas.height = H * scale;
  const ctx = canvas.getContext("2d");
  ctx.scale(scale, scale);

  // Background
  ctx.fillStyle = "#ffffff"; ctx.fillRect(0, 0, W, H);
  // Header band
  ctx.fillStyle = "#2E5BFF"; ctx.fillRect(0, 0, W, 96);
  ctx.fillStyle = "#ffffff"; ctx.font = "800 34px Arial, sans-serif";
  ctx.fillText("DietFlix", pad, 60);
  ctx.font = "20px Arial, sans-serif"; ctx.fillStyle = "#dfe6ff";
  ctx.textAlign = "right"; ctx.fillText("La tua ricetta", W - pad, 58); ctx.textAlign = "left";

  // Title
  let cy = 150;
  ctx.fillStyle = "#1a1a2e"; ctx.font = titleFont;
  titleLines.forEach((l) => { ctx.fillText(l, pad, cy); cy += 52; });
  cy += 8;

  // Nutrition pills
  if (n.kcal != null) {
    const pills = [`${n.kcal} kcal`, `Prot ${n.protein_g ?? "—"}g`, `Carb ${n.carbs_g ?? "—"}g`, `Grassi ${n.fat_g ?? "—"}g`];
    ctx.font = "700 18px Arial, sans-serif";
    let px = pad;
    pills.forEach((p) => {
      const w = ctx.measureText(p).width + 28;
      ctx.fillStyle = "#f0f3ff"; roundRect(ctx, px, cy, w, 40, 20); ctx.fill();
      ctx.fillStyle = "#2E5BFF"; ctx.fillText(p, px + 14, cy + 26);
      px += w + 12;
    });
    cy += 64;
  }

  // Ingredients
  ctx.fillStyle = "#EC0B8C"; ctx.font = h3Font; ctx.fillText("Ingredienti", pad, cy + 24); cy += 44;
  ctx.fillStyle = "#333"; ctx.font = bodyFont;
  ingLines.forEach((ls) => { ls.forEach((l) => { ctx.fillText(l, pad, cy + 22); cy += 30; }); });
  cy += 14;

  // Steps
  ctx.fillStyle = "#EC0B8C"; ctx.font = h3Font; ctx.fillText("Preparazione", pad, cy + 24); cy += 44;
  ctx.fillStyle = "#333"; ctx.font = bodyFont;
  stepLines.forEach((ls) => { ls.forEach((l) => { ctx.fillText(l, pad, cy + 22); cy += 32; }); cy += 8; });

  // Footer
  ctx.fillStyle = "#999"; ctx.font = "16px Arial, sans-serif";
  ctx.fillText("Generato con DietFlix · Documento indicativo", pad, H - 30);

  return canvas;
}

function roundRect(ctx, x, y, w, h, r) {
  ctx.beginPath();
  ctx.moveTo(x + r, y);
  ctx.arcTo(x + w, y, x + w, y + h, r);
  ctx.arcTo(x + w, y + h, x, y + h, r);
  ctx.arcTo(x, y + h, x, y, r);
  ctx.arcTo(x, y, x + w, y, r);
  ctx.closePath();
}
